import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Container } from '../../../../../../components/SearchForm/components/ViewSwitch/components/Badge/components/Container.js';
import { ParagraphXSmallBold } from '../../../../../../primitives/index.js';
export const Badge = () => {
  const {
    t
  } = useTranslation();
  return _jsx(Container, {
    children: _jsx(ParagraphXSmallBold, {
      color: 'contentInversePrimary',
      children: t('searchForm:newBadge')
    })
  });
};